// Packages
import { createApp } from 'vue';

// Modules
import getMedia from '@helpers/breakpoints';

// Vue components
// import HeaderSearch from '@vue-components/HeaderSearch.vue';

const isDesktopMedia = getMedia('lg');

export default function init(): void {
  const header = document.querySelector<HTMLElement>('#js-header')!;

  // Create Vue instance for header
  const vueInstance = createApp({
    name: 'HeaderInstance',
    compilerOptions: {
      delimiters: ['${', '}'],
    },
    components: {
      // HeaderSearch,
    },
    data() {
      return {
        isDesktop: isDesktopMedia.matches,
        isMobileMenuEnabled: false,
        isSearchEnabled: false,
        openDropdowns: [],
        selectedTabs: {} as Record<string, string>,
      };
    },
    created() {
      // Make isMobile responsive
      if (isDesktopMedia.addEventListener) {
        isDesktopMedia.addEventListener('change', this.isDesktopMediaListener);
      } else {
        isDesktopMedia.addListener(this.isDesktopMediaListener);
      }
    },
    beforeUnmount() {
      if (isDesktopMedia.removeEventListener) {
        isDesktopMedia.removeEventListener('change', this.isDesktopMediaListener);
      } else {
        isDesktopMedia.removeListener(this.isDesktopMediaListener);
      }
    },
    methods: {
      isDesktopMediaListener(media: MediaQueryListEvent) {
        this.isDesktop = media.matches;
      },
      // toggleSearch(show: boolean) {
      //   const { headerSearch } = this.$refs as {
      //     headerSearch: InstanceType<typeof HeaderSearch>;
      //   };

      //   headerSearch.toggleModal(show);
      // },
      toggleDropdown(id: number | string, force?: boolean) {
        const open = force === undefined ? !this.openDropdowns.includes(id) : force;

        if (open) {
          this.openDropdowns.push(id);
        } else {
          this.openDropdowns = this.openDropdowns.filter(
            (dropdown: number | string) => dropdown !== id,
          );
        }
      },
      isDropdownOpen(id: number | string) {
        return this.openDropdowns.includes(id);
      },
      selectTab(tabListId: string, tabId: string) {
        return (this.selectedTabs[tabListId] = tabId);
      },
      isTabSelected(tabListId: string, tabId: string) {
        return this.selectedTabs[tabListId] === tabId;
      },
      clearTab(tabListId: string) {
        delete this.selectedTabs[tabListId];
      },
    },
  });

  // Mount the app
  vueInstance.mount(header);
}
